export const eventHandler = (cb, isMobile) => {
  return (event) => {
    if (isMobile && event.type === 'touchstart') {
      cb(event)
    } else if (!isMobile && event.type === 'click') {
      cb(event)
    }
  }
}
